document.addEventListener("DOMContentLoaded", function () {
  const footerLogo = document.querySelector(".footer-block__image-wrapper"); // Adjust selector if needed
  if (footerLogo) {
    footerLogo.addEventListener("click", function (e) {
      e.preventDefault(); // Prevent default link behavior
      window.scrollTo({ top: 0, behavior: "smooth" }); // Smooth scroll to top
    });
  }
});

// --- FREE GIFT LOGIC START ---

// function getGiftsForQuantity(quantity) {
//     const gifts = [];
//     switch (quantity) {
//         case 1:
//             gifts.push('packagex1');  // Gift A
//             break;
//         case 2:
//             gifts.push('packagex2');  // Gift B
//             break;
//         case 3:
//             gifts.push('packagex3');  // Gift C
//             break;
//         case 4:
//             gifts.push('packagex1', 'packagex3');
//             break;
//         case 5:
//             gifts.push('packagex2', 'packagex2');
//             break;
//         case 6:
//             gifts.push('packagex3', 'packagex3');
//             break;
//         case 7:
//             gifts.push('packagex3', 'packagex3', 'packagex1');
//             break;
//         default:
//             const repeatCount = Math.floor(quantity / 3);
//             for (let i = 0; i < repeatCount; i++) {
//                 gifts.push('packagex3');
//             }
//             if (quantity % 3 === 1) {
//                 gifts.push('packagex1');
//             } else if (quantity % 3 === 2) {
//                 gifts.push('packagex2');
//             }
//             break;
//     }
//     return gifts;
// }

// function updateCartGifts() {
//     fetch('/cart.js')
//         .then(response => response.json())
//         .then(cart => {
//             const totalQuantity = cart.items.reduce((sum, item) => sum + item.quantity, 0);
//             const gifts = getGiftsForQuantity(totalQuantity);

//             // Remove existing gifts first
//             const removePromises = cart.items
//                 .filter(item => item.properties && item.properties.is_gift)
//                 .map(item => {
//                     return fetch('/cart/change.js', {
//                         method: 'POST',
//                         headers: { 'Content-Type': 'application/json' },
//                         body: JSON.stringify({ id: item.key, quantity: 0 })
//                     });
//                 });

//             Promise.all(removePromises).then(() => {
//                 // Add new gifts
//                 gifts.forEach(giftHandle => {
//                     fetch(`/products/${giftHandle}.js`)
//                         .then(res => res.json())
//                         .then(product => {
//                             const variantId = product.variants[0].id;
//                             fetch('/cart/add.js', {
//                                 method: 'POST',
//                                 headers: { 'Content-Type': 'application/json' },
//                                 body: JSON.stringify({
//                                     quantity: 1,
//                                     id: variantId,
//                                     properties: { is_gift: true } // Mark as gift
//                                 })
//                             });
//                         });
//                 });
//             });
//         });
// }

// // Run only on cart page
// document.addEventListener('DOMContentLoaded', () => {
//     if (window.location.pathname.includes('/cart')) {
//         updateCartGifts();
//     }
// });

// --- FREE GIFT LOGIC END ---

// -========================== Proceed to checkout on cart page================================

// ========================== CONFIGURABLE PACKAGE HANDLES ==========================
const PACKAGE_X1 = "petyu-karton";
const PACKAGE_X2 = "petyu-verpackung";
const PACKAGE_X3 = "petyu-stickers";

// ========================== Gift Calculation ==========================
function getGiftsForQuantity(quantity) {
  const gifts = [];
  switch (quantity) {
    case 1:
      gifts.push(PACKAGE_X1);
      break;
    case 2:
      gifts.push(PACKAGE_X2);
      break;
    case 3:
      gifts.push(PACKAGE_X3);
      break;
    case 4:
      gifts.push(PACKAGE_X1, PACKAGE_X3);
      break;
    case 5:
      gifts.push(PACKAGE_X3, PACKAGE_X2);
      break;
    case 6:
      gifts.push(PACKAGE_X3, PACKAGE_X3);
      break;
    case 7:
      gifts.push(PACKAGE_X3, PACKAGE_X3, PACKAGE_X1);
      break;
    default:
      const repeatCount = Math.floor(quantity / 3);
      for (let i = 0; i < repeatCount; i++) {
        gifts.push(PACKAGE_X3);
      }
      if (quantity % 3 === 1) {
        gifts.push(PACKAGE_X1);
      } else if (quantity % 3 === 2) {
        gifts.push(PACKAGE_X2);
      }
      break;
  }
  return gifts;
}

/**
 * Utility: fetch JSON convenience wrapper with error fail-fast.
 */
async function fetchJSON(url, options = {}) {
  const res = await fetch(
    url,
    Object.assign(
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      },
      options
    )
  );
  if (!res.ok) {
    const text = await res.text();
    throw new Error("Request failed " + res.status + ": " + text);
  }
  return res.json();
}

/**
 * Gets current cart object.
 */
function getCart() {
  return fetchJSON("/cart.js");
}

/**
 * Remove all existing gift line items (identified by properties.is_gift === true).
 */
async function removeExistingGifts(cart) {
  const giftItems = cart.items.filter(
    (i) => i.properties && i.properties.is_gift
  );
  if (!giftItems.length) return;
  await Promise.all(
    giftItems.map((item) => {
      return fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ id: item.key, quantity: 0 }),
      });
    })
  );
}

/**
 * Add gifts (array of product handles) by retrieving variant IDs.
 */
const variantCache = new Map();
async function addGifts(giftHandles) {
  for (const handle of giftHandles) {
    let variantId;
    if (variantCache.has(handle)) {
      variantId = variantCache.get(handle);
    } else {
      const product = await fetchJSON(`/products/${handle}.js`);
      variantId = product.variants[0].id;
      variantCache.set(handle, variantId);
    }
    await fetchJSON("/cart/add.js", {
      method: "POST",
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
      }),
    });
  }
}

/**
 * Main flow triggered by custom checkout button.
 */
// async function processGiftsAndCheckout() {
//   const btn = document.getElementById('custom-checkout-btn');
//   const statusEl = document.getElementById('gift-status-msg');
//   if (!btn) return;

//   if (btn.dataset.processing === 'true') return;
//   btn.dataset.processing = 'true';

//   const originalText = btn.innerText;
//   btn.innerText = 'Preparing...';
//   btn.disabled = true;
//   statusEl.textContent = '';
//   statusEl.style.color = '#444';

//   try {
//     let cart = await getCart();

//     const nonGiftQty = cart.items
//       .filter(i => !(i.properties && i.properties.is_gift))
//       .reduce((sum, i) => sum + i.quantity, 0);

//     if (nonGiftQty === 0) {
//       statusEl.textContent = 'Add products to qualify for gifts.';
//       btn.innerText = originalText;
//       btn.disabled = false;
//       btn.dataset.processing = 'false';
//       return;
//     }

//     const desiredGifts = getGiftsForQuantity(nonGiftQty);

//     await removeExistingGifts(cart);

//     if (desiredGifts.length) {
//       statusEl.textContent = 'Adding your free gifts...';
//       await addGifts(desiredGifts);
//     }

//     statusEl.textContent = 'Redirecting to checkout...';
//     window.location.href = '/checkout';

//   } catch (err) {
//     console.error(err);
//     statusEl.textContent = 'Error preparing gifts. Please try again.';
//     statusEl.style.color = 'red';
//     btn.innerText = 'Try Again';
//     btn.disabled = false;
//     btn.dataset.processing = 'false';
//     return;
//   }
// }
function isCartCheckoutPackingEnabled() {
  return window.themeCartCheckoutPackingItems === true;
}

async function processGiftsAndCheckout() {
  if (!isCartCheckoutPackingEnabled()) return;

  const btn = document.getElementById("custom-checkout-btn");
  const statusEl = document.getElementById("gift-status-msg");
  if (!btn) return;

  if (btn.dataset.processing === "true") return;
  btn.dataset.processing = "true";

  const originalText = btn.innerText;
  btn.innerText = "Preparing...";
  btn.disabled = true;
  statusEl.textContent = "";
  statusEl.style.color = "#444";

  try {
    let cart = await getCart();

    // 🧼 Step 1: Remove all packing card items BEFORE calculating
    const packingHandles = [PACKAGE_X1, PACKAGE_X2, PACKAGE_X3];
    const packingItems = cart.items.filter((item) =>
      packingHandles.includes(item.handle)
    );

    if (packingItems.length) {
      for (const item of packingItems) {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ id: item.key, quantity: 0 }),
        });
      }

      // Wait a tiny bit to ensure server finishes updates
      await new Promise((resolve) => setTimeout(resolve, 300));

      // Refresh cart after **all** removals complete
      cart = await getCart();
    }

    // 🧮 Step 2: Recalculate based on non-packing items
    const nonGiftQty = cart.items
      .filter((i) => !packingHandles.includes(i.handle))
      .reduce((sum, i) => sum + i.quantity, 0);

    if (nonGiftQty === 0) {
      statusEl.textContent = "Add products to qualify for gifts.";
      btn.innerText = originalText;
      btn.disabled = false;
      btn.dataset.processing = "false";
      return;
    }

    const desiredGifts = getGiftsForQuantity(nonGiftQty);

    // 🎁 Step 3: Add packing cards
    if (desiredGifts.length) {
      statusEl.textContent = "Adding your free gifts...";
      await addGifts(desiredGifts);
    }

    // ✅ Final Step: Redirect to checkout
    statusEl.textContent = "Redirecting to checkout...";
    window.location.href = "/checkout";
  } catch (err) {
    console.error(err);
    statusEl.textContent = "Error preparing gifts. Please try again.";
    statusEl.style.color = "red";
    btn.innerText = "Try Again";
    btn.disabled = false;
    btn.dataset.processing = "false";
  }
}

/**
 * Attach event listener once DOM is ready (cart page only).
 */
document.addEventListener("DOMContentLoaded", () => {
  if (!window.location.pathname.includes("/cart")) return;
  if (!isCartCheckoutPackingEnabled()) return;
  const btn = document.getElementById("custom-checkout-btn");
  if (btn) {
    btn.addEventListener("click", processGiftsAndCheckout);
  }
});

// -========================== Proceed to checkout on cart page================================
